import React from 'react';
import Icon from '../../../components/AppIcon';

const features = [
  {
    icon: 'BrainCircuit',
    title: 'AI-Generated Touchpoints',
    description: 'Personalized monthly messages written by AI — tailored to each client relationship automatically.',
  },
  {
    icon: 'MessageSquare',
    title: 'Local Area Code SMS',
    description: 'Every message sends from a local number matching your client\'s area code for higher open rates.',
  },
  {
    icon: 'Shield',
    title: 'A2P 10DLC Compliant',
    description: 'Fully registered with carrier requirements. Your messages reach inboxes, not spam filters.',
  },
  {
    icon: 'RefreshCw',
    title: 'Set It & Forget It',
    description: 'Onboard a client once and the platform handles follow-ups for years — market updates, check-ins, and more.',
  },
];

const TrustSignals = () => {
  return (
    <div className="space-y-6 px-2">
      <div className="space-y-1">
        <h2 className="text-2xl font-semibold text-foreground leading-tight">
          Stay top-of-mind,<br />
          <span className="text-gradient">without the effort.</span>
        </h2>
        <p className="text-sm text-muted-foreground leading-relaxed pt-1">
          Nurture Buddy.ai automates the touchpoints that turn past clients into repeat business and referrals.
        </p>
      </div>

      <div className="space-y-3">
        {features.map((f) => (
          <div
            key={f.title}
            className="flex items-start gap-4 p-4 rounded-xl transition-smooth"
            style={{ background: 'rgba(13,17,23,0.6)', border: '1px solid rgba(30,45,69,0.8)' }}
          >
            <div
              className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 mt-0.5"
              style={{ background: 'rgba(0,180,216,0.1)', border: '1px solid rgba(0,180,216,0.2)' }}
            >
              <Icon name={f.icon} size={18} className="text-primary" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">{f.title}</p>
              <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">{f.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="flex items-center gap-4 pt-2">
        <div className="flex items-center gap-1.5">
          <Icon name="Lock" size={13} className="text-success" />
          <span className="text-xs text-muted-foreground">SSL Encrypted</span>
        </div>
        <div className="flex items-center gap-1.5">
          <Icon name="CheckCircle" size={13} className="text-success" />
          <span className="text-xs text-muted-foreground">TCPA Compliant</span>
        </div>
        <div className="flex items-center gap-1.5">
          <Icon name="CheckCircle" size={13} className="text-success" />
          <span className="text-xs text-muted-foreground">SOC 2 Ready</span>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;
